var jquery = require("jquery");
var cookie = require("jquery.cookie");
window.$ = window.jQuery = jquery;
require('lazysizes');
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.preloadAfterLoad = true;
import ScrollOut from "scroll-out";

ScrollOut({
	cssProps: {
		viewportY: true,
	},
});


var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.headerContainer').outerHeight();

// READY

$(function () {

	console.log('Website proudly by Imagic Creative!');

	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);

	setInterval(function() {
		if ($('.header-dropdown[data-expanded="true"]').length) {
			$('body').attr('data-menu-expanded', 'true');
		} else {
			$('body').attr('data-menu-expanded', 'false');
		}
	}, 100);


	setInterval(function() {
		if (window.location.hash) {
			// Extract the section number from the hash
			var sectionNumber = window.location.hash.substring(9); // Assuming #section-XXX format
			var section = $('[data-ni-block-id="' + sectionNumber + '"]');
			if (section.length) {
				$('html, body').animate({
					scrollTop: $('[data-ni-block-id="' + sectionNumber + '"]').offset().top
				}, 'slow');
			}

			// Remove the hash from the URL after scrolling
			history.replaceState({}, document.title, window.location.pathname);
			$('header').removeClass('nav-up').removeClass('nav-down');
		}
	}, 250);

	setInterval(function() {
		bodyBg();
	}, 250);

	ticker();

	var scrollTop = $(window).scrollTop();

	galleryScroll(scrollTop);

	if ($('[data-section="listType1"]').length) {
		var firstAccordion = $('[data-section="listType1"]').first().find('button.accordion').first();
		if (firstAccordion.length) {
			firstAccordion.trigger('click');
		}
	}

	readMore();

});

// SCROLL

$(window).on('scroll', function(e) {

	didScroll = true;

	var scrollTop = $(window).scrollTop();

	bodyBg();

	ticker();

});


// RESIZE

$(window).on('resize', function() {

	if ($('.accordion.is-open').length) {
		$('.accordion.is-open').each(function() {
			var content = $(this).parent().find('.accordion-content');

			var maxH = 0;
			content.find('> div').each(function() {
				var divHeight = $(this).outerHeight();
				if ($(window).width() < 1024) {
					maxH += divHeight;
				} else {
					if (divHeight > maxH) {
						maxH = divHeight;
					}
				}
			});

			maxH += 40;

			content.css('max-height', maxH);
		})
	}

	readMore();

});




// ACCORDION
$(document).on('click', '.accordion:not(.is-open)', function(e) {
	// $(this).parent().parent().find('.accordion.is-open').trigger('click');
	$(this).addClass('is-open');
	var content = $(this).parent().find('.accordion-content');

	var maxH = 0;
    content.find('> div').each(function() {
        var divHeight = $(this).outerHeight();
		if ($(window).width() < 1024) {
			maxH += divHeight;
		} else {
			if (divHeight > maxH) {
				maxH = divHeight;
			}
		}
    });

	maxH += 40;

	content.css('max-height', maxH);
});
$(document).on('click', '.accordion.is-open', function(e) {
	$(this).removeClass('is-open');
	var content = $(this).parent().find('.accordion-content');
	content.removeAttr('style');
});

//////////////////////////////////////////








// MENU HOVER

$('header .column-menu .menu-parent').on('click', function() {
	// console.log('CLICK')
	var target = $(this).attr('data-target');
	if ($(this).hasClass('active')) {
		$('header .column-menu .menu-parent').removeClass('active');
		$(this).removeClass('active');
		var dropdowns = $('.header-dropdown[data-dropdown]')
		var dropdown = $('.header-dropdown[data-dropdown="' + target + '"]')
		dropdowns.attr('data-expanded', false);
		dropdown.attr('data-expanded', false);
	} else {
		$('header .column-menu .menu-parent').removeClass('active');
		$(this).addClass('active');
		var dropdowns = $('.header-dropdown[data-dropdown]')
		var dropdown = $('.header-dropdown[data-dropdown="' + target + '"]')
		dropdowns.attr('data-expanded', false);
		dropdown.attr('data-expanded', true);
	}
});
$('header .column-menu .menu-parent').on('mouseover', function() {
	if (isTouchDevice()) {
		return false;
	}
	// console.log('OVER')
	var target = $(this).attr('data-target');
	$('header .column-menu .menu-parent').removeClass('active');
	$(this).addClass('active');
	var dropdowns = $('.header-dropdown[data-dropdown]')
	var dropdown = $('.header-dropdown[data-dropdown="' + target + '"]')
	dropdowns.attr('data-expanded', false);
	dropdown.attr('data-expanded', true);
});
$('body').on('mouseover', function(event) {
	if (isTouchDevice()) {
		return false;
	}
	if (
		!$(event.target).hasClass('menu-parent') && 
		!$(event.target).hasClass('header-menu') && 
		!$(event.target).parent().hasClass('menu-parent') && 
		!$(event.target).closest('.header-dropdown').length && 
		!$(event.target).hasClass('header-dropdown') || 
		$(event.target).closest('section').length
	) {
		// console.log($(event.target))
		// console.log($(event.target).hasClass('header-dropdown'))
		$('header .column-menu .menu-parent-children').removeClass('active');
		var dropdowns = $('.header-dropdown[data-dropdown]')
		dropdowns.attr('data-expanded', false);
	}
});
$('body').on('click', function(event) {
	// if (isTouchDevice()) {
		if (
			!$(event.target).hasClass('menu-parent') && 
			!$(event.target).hasClass('header-menu') && 
			!$(event.target).parent().hasClass('menu-parent') && 
			!$(event.target).closest('.header-dropdown').length && 
			!$(event.target).hasClass('header-dropdown') || 
			$(event.target).closest('section').length
		) {
			$('header .column-menu .menu-parent-children').removeClass('active');
			var dropdowns = $('.header-dropdown[data-dropdown]')
			dropdowns.attr('data-expanded', false);
		}
	// }
});

// MENU TOUCH DESKTOP

$('header .column-menu .menu-parent-children a').on('click', function(e) {
	if (isTouchDevice()) {
		e.preventDefault();
		var dropdowns = $('.header-dropdown[data-dropdown]')
		if ($(this).hasClass('active')) {
			$('header .column-menu .menu-parent-children').removeClass('active');
			dropdowns.attr('data-expanded', false);
		} else {
			var target = $(this).parent().attr('data-target');
			$('header .column-menu .menu-parent-children').removeClass('active');
			$(this).parent().addClass('active');
			var dropdown = $('.header-dropdown[data-dropdown="' + target + '"]')
			dropdowns.attr('data-expanded', false);
			dropdown.attr('data-expanded', true);
		}
	}
});


function hasScrolled() {
	
	if ($('body.mobile-menu-open').length) {
		return;
	}

	if ($('footer[data-scroll="in"]').length && $(window).width() < 1024) {
		$('header').removeClass('nav-up').addClass('nav-down');
		return;
	}
		
	var st = $(window).scrollTop();
	// Make sure they scroll more than delta
	if(Math.abs(lastScrollTop - st) <= delta)
		return;
	// If they scrolled down and are past the navbar, add class .nav-up.
	// This is necessary so you never see what is "behind" the navbar.

	if (st > lastScrollTop && st > navbarHeight) {
		// Scroll Down
		if ($('header').hasClass('nav-down')) {
			$('header').removeClass('nav-down').addClass('nav-up');
		}
	} else {
		// Scroll Up
		if(st > navbarHeight && (st + $(window).height() < $(document).height())) {
			$('header').removeClass('nav-up').addClass('nav-down');
		} 
		
		if(st < 5) {
			$('header').removeClass('nav-up').removeClass('nav-down');
		}
	}

	
	lastScrollTop = st;
} 


function isTouchDevice() {
	return (('ontouchstart' in window) ||
	   (navigator.maxTouchPoints > 0) ||
	   (navigator.msMaxTouchPoints > 0));
}

////////////////////////////////////////












function bodyBg() {
	var bgChanged = false;
	$('section[data-bg][data-scroll="in"]').each(function() {

		var style = $(this).css('--viewport-y');
		var viewportYValue = parseFloat(style);
		
		
		if (!bgChanged && $(this).attr('data-bg') && (viewportYValue >= -0.8 && viewportYValue < 1)) {
			$('body').attr('data-bg', $(this).attr('data-bg'));
			// console.log('viewportYValue ' + viewportYValue)
			// console.log('data-bg ' + $(this).attr('data-bg'))
			bgChanged = true;
		}
	});
}














// NUMBER TICKER
var tickerTriggered = false;

function ticker() {
	if (!tickerTriggered) {
		var numberDiv = $('[data-section="textType3"] .number .value');
		if (!numberDiv.length) {
			return false;
		}
		var inView = isElementInViewport(numberDiv[0]); // Check if the element is in view
		if (inView) {
			numberDiv.each(function () {
				var currentValue = $(this).text().replace(/,/g, ''); // Remove commas before parsing
				var targetValue = parseFloat(currentValue);
				$(this).prop('Counter', 0).animate({
					Counter: targetValue
				}, {
					duration: 1500,
					easing: 'swing',
					step: function (now) {
						$(this).text(addCommas(Math.ceil(now))); // Add commas back after rounding
					}
				});
			});
			tickerTriggered = true; // Set the flag to true after triggering the animation
		}
	}
}

// Function to check if an element is in the viewport
function isElementInViewport(el) {
	var rect = el.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}

// Function to add commas to numbers
function addCommas(nStr) {
	nStr += '';
	var x = nStr.split('.');
	var x1 = x[0];
	var x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}

////////////////////////////////////////









// MOBILE MENU

$('[data-menu-trigger] .hamburger').on("click", function(e) {
	e.stopPropagation();
	$(this).toggleClass('open');
	$('.headerContainer').add('body').toggleClass('mobile-menu-open');
	if ($(window).scrollTop() > 0) {
		$('header').addClass('nav-down');
	}
	if ($(this).hasClass('open')) {
		$(this).attr('aria-expanded', true);
		$('.menu-main-mobile-container').attr('aria-hidden', false);
		setTimeout(() => {
			$('.menu-main-mobile-container .bg-mobile').addClass('!opacity-100');
		}, 300);
	} else {
		$(this).attr('aria-expanded', false);
		$('.menu-main-mobile-container').attr('aria-hidden', true);
		$('.menu-main-mobile-container .bg-mobile').removeClass('!opacity-100');
	}
});

$(document).on('click', '.menu-main-mobile li.with-menu-sub button', function(e) {
	e.stopPropagation();
	$(this).parent().toggleClass('open');
	var submenu = $(this).attr('data-submenu');
	if ($(this).parent().hasClass('open')) {
		if (submenu) {
			$('.submenu-screen .menu-sub[data-submenu="' + submenu + '"]').css('display', 'flex');
		}
		$('.menu-main-mobile-container').attr('data-submenu-open', true);
	} else {
		$('.submenu-screen .menu-sub').hide();
		$('.menu-main-mobile-container').attr('data-submenu-open', false);
	}
});
$(document).on('click', '.submenu-screen .back-link', function(e) {
	e.stopPropagation();
	$('.submenu-screen .menu-sub').hide();
	$('.menu-main-mobile-container').attr('data-submenu-open', false);
	$('.menu-main-mobile li.with-menu-sub').removeClass('open');
});

$(document).on('click', 'body.mobile-menu-open .backdrop', function(e) {
	e.stopPropagation();
	$('[data-menu-trigger] .hamburger').trigger('click');
});

////////////////////////////////////////







// MAP MENU
$('[data-menu-desktop-trigger]').on("click", function(e) {
	e.stopPropagation();
	var hamburger = $(this).find('.hamburger');
	hamburger.toggleClass('open');
	if (hamburger.hasClass('open')) {
		hamburger.attr('aria-expanded', true);
		$('body').attr('data-menu-visible', true);
		$('body').attr('data-bg', 'primary-four');
	} else {
		hamburger.attr('aria-expanded', false);
		$('body').attr('data-menu-visible', false);
		$('body').attr('data-bg', 'white');
	}
});

////////////////////////////////////////








// READ MORE

function readMore() {
	var readMore = $('[data-read-more]');
	var type = readMore.attr('data-type') ?? 'default';
	if (type != 'desktop' && $(window).width() >= 1280) {
		$('[data-read]').show();
		$('[data-read-more]').hide();
		$('[data-read-less]').hide();
		return false;
	}
	if (readMore.length) {
		readMore.each(function() {
			var id = $(this).attr('data-read-more');
			$('[data-read-more="' + id + '"]').show();
			$('[data-read="' + id + '"]').hide();
		})
	}
}

$(document).on('click', '[data-read-more]', function(e) {
	var id = $(this).attr('data-read-more');
	$(this).hide();
	$('[data-read-less="' + id + '"]').show();
	$('[data-read="' + id + '"]').show();
});

$(document).on('click', '[data-read-less]', function(e) {
	var id = $(this).attr('data-read-less');
	$(this).hide();
	$('[data-read-more="' + id + '"]').show();
	$('[data-read="' + id + '"]').hide();
});

////////////////////////////////////////








// GALLERY SCROLL

function throttle(callback, limit) {
	let waiting = false;
	return function () {
		if (!waiting) {
			callback.apply(this, arguments);
			waiting = true;
			setTimeout(function () {
					waiting = false;
			}, limit);
		}
	};
}

var scrollHandler = throttle(function () {
	if ($(window).width() < 1280) {
		return false;
	}
	var scrollTop = $(window).scrollTop();
	requestAnimationFrame(function () {
		galleryScroll(scrollTop);
	});
}, 150); // Adjust the throttle limit (in milliseconds) as needed

$(window).on('scroll', scrollHandler);

function galleryScroll(scrollTop) {
	if ($(window).width() < 1280) {
		return false;
	}
	var section = $('[data-section="imageType3"][data-scroll="in"]');
	if (!section.length) {
		return false;
	}
	section.each(function() {
		var row = $(this).find('.row-gallery')
		var rowOffsetTop = row.offset().top;
		var rowWidth = 0;
		var images = row.find('.image-container');
		var viewportWidth = $(window).width();

		images.each(function() {
			rowWidth += $(this).width();
		});
		var translateX = scrollTop - rowOffsetTop + $(window).height();
		if (translateX < 0) {
		  translateX = 0;
		} else if (translateX > rowWidth - viewportWidth) {
		  translateX = rowWidth - viewportWidth;
		}
		row.css('transform', 'translateX(-' + translateX + 'px)');
	})

}

////////////////////////////////////////








// SECTION GALLERY POPUP

$(document).on('click', '[data-reveal-gallery]', function(e) {
	var aside = $('[data-gallery]');
	if (aside.length) {
		aside.attr('data-revealed', 'true');
	}
	var newHash = $(this).attr('data-reveal-gallery');
	if (newHash) {
		setTimeout(() => {
			window.location.hash = newHash;
		}, 150);
	}
});

$(document).on('click', '[data-hide-gallery]', function(e) {
	var aside = $('[data-gallery]');
	if (aside.length) {
		aside.attr('data-revealed', 'false');
	}
});

////////////////////////////////////////








// GALLERY FILTERS

const galleryImages = $('[data-section="imageType4"]').first();
const galleryVideos = $('[data-section="videoType1"]').first();

$(document).on('click', '.nav-radio[data-gallery-type]', function(e) {
	var type = $(this).attr('data-gallery-type');
	$('.nav-radio[data-gallery-type]').removeClass('active');
	$(this).addClass('active');
	if (type == "image") {
		galleryImages.show();
		galleryVideos.hide();
	} else {
		galleryImages.hide();
		galleryVideos.show();
	}
	var currentUrl = window.location.href;
	currentUrl = decodeURIComponent(currentUrl);
	var url = new URL(currentUrl);
	url.searchParams.set('type', type);
	window.history.replaceState({}, document.title, url.toString());
});

$(document).on('click', '[data-section="galleryNav"] [data-filter-trigger]', function(e) {
    var filter = $(this).attr('data-filter-trigger');
    $('[data-section="galleryNav"] [data-filter-trigger]').removeClass('btn-small-active');
    $(this).addClass('btn-small-active');
	if ($(window).width() < 768) {
		$(this)[0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
	}
	if (filter == 'all') {
		$('[data-filters]').show();
	} else {
		$('[data-filters]').hide();
		$('[data-filters]').each(function() {
			var filters = $(this).attr('data-filters').split(',');
			if (filters.includes(filter)) {
				$(this).show();
			}
		});
	}
	var currentUrl = window.location.href;
	currentUrl = decodeURIComponent(currentUrl);
	var url = new URL(currentUrl);
	url.searchParams.set('filter', filter);
	window.history.replaceState({}, document.title, url.toString());
});

$(function () {
	var type = getUrlParameter('type');
	var filter = getUrlParameter('filter');
	if ((type || filter) && (galleryImages.length || galleryVideos.length)) {
		if (type.length && $('.nav-radio[data-gallery-type="' + type + '"]').length) {
			$('.nav-radio[data-gallery-type="' + type + '"]').trigger('click');
		}
		if (filter.length && $('[data-section="galleryNav"] [data-filter-trigger="' + filter + '"]').length) {
			$('[data-section="galleryNav"] [data-filter-trigger="' + filter + '"]').trigger('click');
		}
	}
});

////////////////////////////////////////





// HELPERS

window.getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};  

///////////////////////////////////////





// HOME ANIMATION

// const splash = $('aside.splash');
// $(function () {
// 	if (splash.length) {
// 		if (window.craftLive) {
// 			if ($.cookie('splash')) {
// 				splash.children().remove();
// 				splash.fadeOut();
// 				return false;
// 			}
// 			$.cookie('splash', true);
// 		}
// 		setTimeout(() => {
// 			splash.find('svg').show();
// 			splash.find('svg').addClass('spin');
// 			splash.find('svg .logo-text').addClass('fadeIn');
// 			splash.find('.bg').addClass('fadeIn');
// 		}, 600);
// 		if (window.craftLive) {
// 			setTimeout(() => {
// 				splash.fadeOut();
// 			}, 4000);
// 		}
// 	}
// });

///////////////////////////////////////




// PRINT TRIGGER

$(document).on('click', '[data-print-trigger]', function() {
	$(this).addClass('downloading')
	if (!$(this).hasClass('link')) {
		$(this).find('span').text('Downloading')
	}
	var id = $(this).attr('data-print-trigger');
	var title = $(this).attr('data-stage-title');
    const iframe = $('<iframe>', {
        src: `/map-download?target=${id}&title=${title}`,
        class: 'h-screen w-screen -z-1 absolute opacity-0 pointer-events-none bottom-[-10000px] left-[-10000px]'
    });
    $('body').append(iframe);
});

//////////////////////////////////////




// PRINT TRIGGER

$(document).on('click', '[data-price-trigger]', function() {
	$(this).addClass('downloading')
	if (!$(this).hasClass('link')) {
		$(this).find('span').text('Downloading')
	}
	var id = $(this).attr('data-price-trigger');
	var title = $(this).attr('data-stage-title');
    const iframe = $('<iframe>', {
        src: `/price-download?target=${id}&title=${title}`,
        class: 'h-screen w-screen -z-1 absolute opacity-0 pointer-events-none bottom-[-10000px] left-[-10000px]'
    });
	console.log(id)
    $('body').append(iframe);
});



$(document).ready(function() {
	const _href = window.location.href;
	if (_href.indexOf('map-download-page') || _href.indexOf('price-download-page')) {
		$('[data-price-trigger].hidden-download-button, [data-print-trigger].hidden-download-button').trigger('click');
	}
})

//////////////////////////////////////



// Subscribe popup
const announcement = $('aside[data-type="announcement"]');

$(document).ready(function() {
	// announcements
	if (!localStorage.getItem('announcementClosed')) {		
		announcement.stop().fadeIn(function () {
			// This runs after fadeIn completes
			if ($('#map').length && !$('#map[data-component]').length && $('[data-map-panel]').length) {
				$('main').css('padding-top', announcement.outerHeight() + 'px');
			}
			if ($('.headerContainer').length) {
				var newHeight = $('.headerContainer').outerHeight() + announcement.outerHeight();
				$('.headerContainer, header').height(newHeight);
			}
		});
	}

	$('.close-announce').on('click', function() {
		announcement.stop().slideUp(function () {
			// This runs after fadeIn completes
			if ($('#map').length && !$('#map[data-component]').length && $('[data-map-panel]').length) {
				$('main').css('padding-top','0px');
			}
			if ($('.headerContainer').length) {
				$('.headerContainer, header').height(navbarHeight);
			}
		});
		localStorage.setItem('announcementClosed', 'true');
	})

	// subscribe popup
	// 5 seconds load popup
	var popupTimout = setTimeout(function() {
		// console.log('triggered by timeout');
		initPopup();
		clearTimeout(popupTimout);
	}, 5000);

	//page scroll 50% init popup
	var windowScrollTrigger = $(document).height() / 2;
	$(window).scroll(function() {
		if ($(window).scrollTop() > windowScrollTrigger) {
			// console.log('triggered by pagescroll');
			initPopup();
		}
	});

	// exit intent
	$(document).on('mouseleave', function(e) {
		if (e.clientY < 0) {
			// console.log('triggered by exit intent');
			initPopup();
		}
	});

	// bind events
	$('#subscribePopup').on('freeform-ajax-success', function(event) {
		localStorage.setItem('subscribePopup', 'true');
		$('#subscribe-popup').find('form > *:not(.freeform-form-success)').css('opacity','0');
	})

	$('#subscribe-popup button.close').on('click', function() {
		localStorage.setItem('subscribePopup', 'true');
		$('#subscribe-popup').stop().fadeOut();
	})

	function initPopup() {
		if (!localStorage.getItem('subscribePopup') && !$('#subscribe-popup').data('subscribe-popup-init')) {
			$('#subscribe-popup').stop().fadeIn();	
			$('#subscribe-popup').data('subscribe-popup-init', true);
		}
	}
})

//data layer additionals
window.formDataStore = {};

function getFormData(formElement) {
    const excludeFields = ['CRAFT_CSRF_TOKEN', 'formHash', 'freeform-action', 'freeform_payload', 'action', 'pageUrl', 'subscribe', 'recipients'];
    return $(formElement).serializeArray().reduce((obj, item) => {
        if (!excludeFields.includes(item.name)) {
            obj[item.name] = item.value;
        }
        return obj;
    }, {});
}

// Enhanced submit handler with better logging
$('.freeform-form').each(function() {
    var $form = $(this);
    var formId = $form.attr('id');
    
    $form.on('submit', function() {
        const formData = getFormData($form);
        window.formDataStore[formId] = formData;
    });
});

// Enhanced GTM handler with better debugging
document.addEventListener('freeform-gtm-data-layer-push', function(event) {
    const form = event.form;
    const formId = form.id;
    
    if (window.formDataStore[formId]) {
        event.payload.formData = window.formDataStore[formId];
    } else {
        console.error(`[GTM EVENT] No data found for ${formId}!`);
    }
});